import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { ICommitmentData } from 'legacy/lut/services/partner360/commitment/models/apiCommitmentData'

import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'
import MeasureController from 'core/analytics/MeasureController'

import { ITabProps } from '../p360Tabs'

export interface ICommitmentContactSelectionProps {
  pid: string
  metrics: MeasureController
  flexWidth?: FlexDirectionBreak
  onApply: (item: IObjectAny | ICommitmentEditorItem) => void
}

export enum CommitmentTypes {
  Manager = 'manager',
  PBM = 'hp',
  Partner = 'partner',
}

export interface ICommitmentEditorItem extends ICommitmentData {
  IsPBMSigned: boolean

  CanSignOnBehalf: boolean
  ActionDateTime?: Date
}

export interface ICommitmentEditorProps {
  commitmentEditorItem: ICommitmentEditorItem
  widgetParams: ITabProps

  pid: string
  fyear: number
  programType: ProgramTypes
  isPower: boolean
  isDistributor: boolean
  canEditPartner: boolean
  currentBlockMessage: string
  //canSignOnBehalf: boolean

  showSignOffDialog: (show: boolean, item: ICommitmentEditorItem) => void
  showRefuseDialog: (show: boolean, item: ICommitmentEditorItem) => void
  showResendDialog: (show: boolean, item: ICommitmentEditorItem) => void
  showDropDialog: (show: boolean, item: ICommitmentEditorItem) => void
  showManagerDialog: (show: boolean, item: ICommitmentEditorItem) => void
  showPbmDialog: (show: boolean, item: ICommitmentEditorItem) => void
  showDeleteDialog: (item: ICommitmentEditorItem) => void
  showSelectPartnerContactDialog: (show: boolean, item: ICommitmentEditorItem) => void
  confirmManager: (item: ICommitmentEditorItem) => void
}

export type TSize = 'small' | 'normal'

export enum CommitmentStatuses {
  Dropped = 'jbp-commitment-status-dropped',
}
